import clsx from "clsx";
import React from "react";

import styles from "./DatePicker.module.css";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  label?: string;
  labelInside?: boolean;
}

const DatePicker = (props: Props) => {
  const { id, invalid, label, labelInside, ...rest } = props;
  const className = clsx(
    styles.datePicker,
    labelInside && styles["label-inside"],
  );
  const inputClassname = invalid ? clsx(styles.invalid) : undefined;

  return (
    <div className={className}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        className={inputClassname}
        id={id}
        type="date"
        onClick={(e) => (e.target as HTMLInputElement).showPicker?.()}
        {...rest}
      />
    </div>
  );
};

export default DatePicker;
